import * as types from "~/actions/umc/submitPayment/types";

const initialState = {
  data: {},
  isRedirectToPaymentSupportPage: false,
  errorMsg: "",
  errorBooking: ""
};

export default function umcSubmitPayment(state = initialState, action) {
  switch (action.type) {
    case types.UMC_SUMBIT_PAYMENT_SUCCESS:
      return {
        ...state,
        data: action.data,
        isRedirectToPaymentSupportPage: action.data.payment.method_id === 6
      };
    case types.UMC_SUMBIT_PAYMENT_FAIL:
      // const {
      //   error_code: errorCode,
      //   error_message: errorMessage,
      //   booking_info: bookingInfo
      // } = action.error;
      // if (errorCode === 1011) {
      //   console.log(errorCode);
      //   return {
      //     ...state,
      //     errorMsg:
      //       errorMessage.substring(0, errorMessage.lastIndexOf(":")) +
      //       ": Chuyên khoa " +
      //       bookingInfo.subject.name
      //   };
      // }
      return {
        ...state,
        errorMsg: action.error,
        errorBooking: action.error
      };
    case types.HIDE_ALERT_INFO_SUBMIT_FAIL:
      return {
        ...state,
        errorMsg: "",
        errorBooking: ""
      };
    case types.CANCEL_REDIRECT_TO_PAYMENT_SUPPORT_PAGE:
      return { ...state, isRedirectToPaymentSupportPage: false };
    case types.CLEAR_UMC_PAYMENT_SUPPORT_INFO:
      return initialState;
    default:
      return state;
  }
}
